import React from 'react';
import { Link } from 'react-router-dom';
import { motion, HTMLMotionProps } from 'framer-motion';
import styles from './Button.module.css';

interface ButtonProps extends Omit<HTMLMotionProps<'button'>, 'children'> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  to?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  icon,
  iconPosition = 'right',
  className = '',
  to,
  ...props
}) => {
  const buttonClasses = [
    styles.button,
    styles[`button--${variant}`],
    styles[`button--${size}`],
    fullWidth ? styles['button--full'] : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      <span className={styles.button__content}>
        {icon && iconPosition === 'left' && (
          <span className={styles.button__icon}>{icon}</span>
        )}
        <span className={styles.button__text}>{children}</span>
        {icon && iconPosition === 'right' && (
          <span className={styles.button__icon}>{icon}</span>
        )}
      </span>
      <span className={styles.button__glow} />
    </>
  );

  if (to) {
    return (
      <Link to={to} className={buttonClasses} style={{ textDecoration: 'none' }}>
        {content}
      </Link>
    );
  }

  return (
    <motion.button
      className={buttonClasses}
      {...props}
    >
      {content}
    </motion.button>
  );
};

export default Button;
